import React from "react";
import { DropdownCheckIcon } from "../../../../../Icons";

const TransferTypeButton = ({ icon, title, subTitle, type, selectedType }) => {
  let selected = type === selectedType;
  return (
    <div className="relative cursor-pointer">
      {selected && (
        <div className="absolute w-6 h-6 flex pt-0.5 justify-center right-0 top-0 bg-primary-bg rounded-full shadow border-2 border-white">
          <DropdownCheckIcon />
        </div>
      )}
      <div
        className={`flex justify-start items-center space-x-3 border-divider px-6 py-5 rounded-3xl border-2 ${
          selected
            ? "transfer-option-selected"
            : "transfer-option-default"
        }
      `}
      >
        <div
          className={`p-2 ${
            selected ? "transfer-option-icon-selected" : "transfer-option-icon-default"
          } rounded-full`}
        >
          {icon}
        </div>
        <div className="space-y-1">
          <div className="transfer-option-title text-sm font-medium leading-tight tracking-tight">
            {title}
          </div>
          <p className="text-sm transfer-option-sub-title leading-tight tracking-tight">
            {subTitle}
          </p>
        </div>
      </div>
    </div>
  );
};

export default TransferTypeButton;
